var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hero/Outline/information-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 2.66536C5.05513 2.66536 2.66732 5.05318 2.66732 7.9987C2.66732 10.9442 5.05513 13.332 8.00065 13.332C10.9462 13.332 13.334 10.9442 13.334 7.9987C13.334 5.05318 10.9462 2.66536 8.00065 2.66536ZM1.33398 7.9987C1.33398 4.3168 4.31875 1.33203 8.00065 1.33203C11.6826 1.33203 14.6673 4.3168 14.6673 7.9987C14.6673 11.6806 11.6826 14.6654 8.00065 14.6654C4.31875 14.6654 1.33398 11.6806 1.33398 7.9987ZM7.33398 5.33203C7.33398 4.96384 7.63246 4.66536 8.00065 4.66536H8.00732C8.37551 4.66536 8.67398 4.96384 8.67398 5.33203C8.67398 5.70022 8.37551 5.9987 8.00732 5.9987H8.00065C7.63246 5.9987 7.33398 5.70022 7.33398 5.33203ZM6.66732 7.9987C6.66732 7.63051 6.96579 7.33203 7.33398 7.33203H8.00065C8.36884 7.33203 8.66732 7.63051 8.66732 7.9987V9.9987C9.03551 9.9987 9.33398 10.2972 9.33398 10.6654C9.33398 11.0336 9.03551 11.332 8.66732 11.332H8.00065C7.63246 11.332 7.33398 11.0336 7.33398 10.6654V8.66536C6.96579 8.66536 6.66732 8.36689 6.66732 7.9987Z",
    fill: "#F2AA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.3d3c1eefd866143df8c564528acc1b44.svg";
export { ForwardRef as ReactComponent };